export var GeoProviderEnum;
(function (GeoProviderEnum) {
    GeoProviderEnum["GOOGLE_MAPS"] = "GoogleMapsProvider";
    GeoProviderEnum["ARCGIS"] = "ArcgisProvider";
    GeoProviderEnum["HERE"] = "HereProvider";
    GeoProviderEnum["MAP_QUEST"] = "MapQuestProvider";
})(GeoProviderEnum || (GeoProviderEnum = {}));
//# sourceMappingURL=GeoProviderEnum.js.map